<div class="or" *ngIf="!first && useAnd">And</div>
<div class="or" *ngIf="!first && !useAnd">Or</div>
<div class="row">
  <input [class.negated]="field.negate" [(ngModel)]="field.text"/>
  <button class="negate-field-button" (click)="onNegate()">!</button>
  <button class="delete-field-button" (click)="onClick()">x</button>
</div>
